import {createSlice} from "@reduxjs/toolkit";



export const clientSlice = createSlice({

    name: "clientDetails",

    initialState: {

        selectedClient: {},

        isClientModal: false,

        isProjectModal: false,

        selectedClientProjects: [],

        loading: false



    },

    reducers: {

        setSelectedClient(state, action){

            state.selectedClient = action.payload

        },

        setIsClientModal(state, action){

            state.isClientModal = action.payload

        },

        setisProjectModal(state, action){

            state.isProjectModal = action.payload

        },

        setSelectedClientProjects(state, action){

            state.selectedClientProjects = action.payload

        },
        setLoading(state, action){
            state.loading = action.payload
        }

    }

})



export const { setSelectedClient, setIsClientModal, setisProjectModal, setSelectedClientProjects,setLoading } = clientSlice.actions;



